module.exports = __webpack_public_path__ + "media/images/emoticons/smile-8b7be3c8a36e2783dacafc42f6cdeeb8.gif";